import {formattedImageLink} from '../formattedImageLink';
import type {ParseBannersParams} from './types';

export const parseBanners = async ({banners, isDesktop}: ParseBannersParams) => {
	if (!banners?.listaConteudos) {
		return [];
	}

	const parsedBanners = await Promise.all(
		banners.listaConteudos.map(async banner => {
			// eslint-disable-next-line no-underscore-dangle
			const link = banner.campos?.linkVideoYoutube?._content ?? '';

			const image = await formattedImageLink({
				linkImage: isDesktop
					? banner.campos?.imagemCapaDesktop
					: banner.campos?.imagemCapaMobile,
				linkVideo: link,
			});

			return {
				link,
				image,
				imageAlt: isDesktop
					? banner.campos.imagemCapaDesktop_alt
					: banner.campos.imagemCapaMobile_alt,
			};
		}),
	);

	return parsedBanners;
};
